import { initializeApp, FirebaseApp } from 'firebase/app';
import { getDatabase, Database, ref, push, set } from 'firebase/database';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA6jAgvv49UNNdC9_-WqalyjAqZ_87AMn4",
  authDomain: "auditleats.firebaseapp.com",
  databaseURL: "https://auditleats-default-rtdb.firebaseio.com",
  projectId: "auditleats",
  storageBucket: "auditleats.appspot.com",
  messagingSenderId: "385828205618",
  appId: "1:385828205618:web:7c0ac25daee9eba8ca782b",
  measurementId: "G-2DSYZ61SDX"
};

// Verificar que estamos en el navegador antes de inicializar Firebase
let app: FirebaseApp | undefined;
let database: Database | undefined;
let analytics: Analytics | undefined;

// Solo inicializar Firebase en el cliente, no en el servidor
if (typeof window !== 'undefined') {
  try {
    // Initialize Firebase
    app = initializeApp(firebaseConfig);
    
    // Initialize Realtime Database
    database = getDatabase(app);
    
    // Initialize Analytics
    analytics = getAnalytics(app);
    
    console.log('Firebase initialized successfully');
  } catch (error) {
    console.error('Error initializing Firebase:', error);
  }
}

export { app, database, analytics };

export type { Database, FirebaseApp, Analytics };
